import { render, staticRenderFns } from "./ChatbotComponent.vue?vue&type=template&id=223585d1&scoped=true"
import script from "./ChatbotComponent.vue?vue&type=script&lang=js"
export * from "./ChatbotComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatbotComponent.vue?vue&type=style&index=0&id=223585d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223585d1",
  null
  
)

export default component.exports